import { required, minLength, maxLength, helpers } from 'vuelidate/lib/validators'
import { ref } from 'vue'
import {
  GenericRequiredValidation,
  GenericMinLengthValidation,
  GenericUrlValidation,
  GenericMaxLengthValidation
} from '@locaweb/design-system-vue'

const validateSpecialCharacters = helpers.regex('alpha', /^[a-zA-Z0-9-]+$/)

class Domain {
  get model () {
    return ref({
      subdomain: ref(''),
      tld: ref('.com.br')
    })
  }

  get validations () {
    return {
      domain: {
        subdomain: {
          required,
          minLength: minLength(2),
          maxLength: maxLength(64),
          specialCharacters: validateSpecialCharacters
        },
        tld: { required }
      }
    }
  }

  get validationErrors () {
    return {
      subdomainErrors () {
        const subdomain = this.$v.domain.subdomain
        let errors = null

        if (!subdomain.required) {
          errors = GenericRequiredValidation(subdomain)
        }

        if (!subdomain.specialCharacters) {
          errors = GenericUrlValidation(subdomain)
        }

        if (!subdomain.minLength) {
          errors = GenericMinLengthValidation(subdomain, 2)
        }

        if (!subdomain.maxLength) {
          errors = GenericMaxLengthValidation(subdomain, 64)
        }

        return this.serverError ? this.serverError : errors
      },
      tldErrors () {
        return GenericRequiredValidation(this.$v.domain.tld)
      }
    }
  }
}

export default new Domain()
